<template>
  <div class="poll-widget" :style="style">
    <poll-widget-question class="question"
                          :widget="widget"
                          :initial-selected="initiallySelected"
                          :options="widget.options"
                          @option-clicked="answered"></poll-widget-question>
  </div>
</template>

<script>
import _ from 'lodash';
import PollWidgetQuestion from './PollWidgetQuestion.vue';

export default {
  name: 'PollWidgetView',
  components: {
    PollWidgetQuestion,
  },
  data() {
    return {
      initiallySelected: null,
    };
  },
  props: {
    widget: {
      type: Object,
    },
  },
  created() {
    this.initiallySelected = localStorage.getItem(`riseup.${this.widget.id}`);
  },
  computed: {
    style() {
      return {
        top: `${this.widget.top}px`,
        zIndex: this.widget.zIndex,
      };
    },
  },
  methods: {
    getAnswerType(answer) {
      if (answer) {
        return _.find(this.widget.options, { text: answer }).type;
      }
      return '';
    },
    answered(answer) {
      localStorage.setItem(`riseup.${this.widget.id}`, answer);

      this.$emit('userInteraction', {
        pollType: this.widget.isOpinionPoll ? 'opinion' : 'regular',
        eventName: 'StoryPollAnswerClicked',
        pollName: this.widget.name,
        answer,
        answerType: this.getAnswerType(answer),
        pollId: this.widget.id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.poll-widget {
  position: absolute;
  display: flex;
  width: 430px;
  left: 0;

  .question {
    width: 100%;
    margin-left: 30px;
    margin-right: 30px;
  }
}
</style>
